import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function CategoryGrid({ categories }) {
  const slug = (n) => n.toLowerCase().replace(/\s+/g, "-");
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6" data-testid="homepage-category-grid">
      <div className="mb-10 text-center">
        <span className="font-spec text-xs font-semibold uppercase tracking-[0.2em] text-[#10B981]">Our Range</span>
        <h2 className="mt-2 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
          Shop by Category
        </h2>
        <div className="mx-auto mt-3 h-1 w-12 rounded-full bg-gradient-to-r from-[#10B981] to-[#25D366]" />
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat, i) => (
          <Link
            key={cat.id || cat.name}
            to={`/catalogue?category=${encodeURIComponent(cat.name)}`}
            data-testid={`category-card-${slug(cat.name)}`}
            className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-2xl border border-slate-200 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl animate-fade-up"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            {cat.image ? (
              <img src={cat.image} alt={cat.name} loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
            ) : (
              <div className="absolute inset-0 bg-slate-200" />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B3D] via-[#0B1B3D]/50 to-transparent" />
            <div className="relative z-10 p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-display text-xl font-bold text-white">{cat.name}</h3>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#10B981] text-white transition-transform group-hover:rotate-45">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
              {cat.description && <p className="mt-1 text-sm text-slate-300 line-clamp-1">{cat.description}</p>}
            </div>
          </Link>
        ))}

        <div
          data-testid="category-card-more-coming"
          className="group relative flex h-56 flex-col justify-end overflow-hidden rounded-2xl border border-slate-200 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl animate-fade-up"
          style={{ animationDelay: `${categories.length * 60}ms` }}
        >
          <img src="/upcoming-products.jpg" alt="More products coming soon" loading="lazy"
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0B1B3D] via-[#0B1B3D]/60 to-[#0B1B3D]/20" />
          <span className="absolute right-4 top-4 z-10 rounded-full bg-[#10B981] px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white shadow-md">
            Coming Soon
          </span>
          <div className="relative z-10 p-5">
            <h3 className="font-display text-xl font-bold text-white">Other Products</h3>
            <p className="mt-1 text-sm text-slate-200">We're on the service of adding more products.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
